import React from 'react';
import { PaymentMethod, PriceCountry } from '../../../../../constants/merchantPriceCatalog';
import { SalesSegment } from '../../../../../types/onboarding/OnboardStore';
import {
    cellKey,
    feeFields,
    PriceFormValues,
    productRowsOf,
} from '../../../../../services/helpers/merchantPrices';
import PaymentMethodCodes, { hasFee } from './PaymentMethodCodes';
import { Dash, Td } from './styles';

interface PaymentMethodViewRowProps {
    method: PaymentMethod;
    country: PriceCountry;
    segment: SalesSegment;
    /** The loaded values the row shows. */
    values: PriceFormValues;
}

/** One payment method in one country and segment as text, for users who may only view the price list. */
const PaymentMethodViewRow: React.FC<PaymentMethodViewRowProps> = ({
    method,
    country,
    segment,
    values,
}: PaymentMethodViewRowProps) => {
    const key = cellKey(method.id, country.code, segment);
    const active = values.active[key] === true;

    return (
        <tr data-testid={`price-row-${method.id}-${country.code}-${segment}`} data-active={active}>
            <Td>
                <PaymentMethodCodes
                    method={method}
                    rows={productRowsOf(values.products, key)}
                    rowKey={row => row.productCode}
                    renderValidity={row =>
                        (row.validFrom || row.validUntil) && (
                            <span>
                                {' '}
                                · {row.validFrom || '…'} – {row.validUntil || '…'}
                            </span>
                        )
                    }
                />
            </Td>
            <Td>{active ? 'Yes' : <Dash>–</Dash>}</Td>
            {feeFields.map(field => (
                <Td key={field} $numeric>
                    {(hasFee(method, field) && values.fees[key]?.[field]) || <Dash>–</Dash>}
                </Td>
            ))}
        </tr>
    );
};

export default PaymentMethodViewRow;
